import { OfflinePurchase } from '@@types'
import classNames from 'classnames'
import { ReactSVG } from 'react-svg'

import Button from '@shared/ui/button'
import { formatDate } from '@shared/uttils/formatDate'

import styles from './styles.module.scss'

export default function OfflineOrderHeader ({
  order,
  isDetail,
  handleDetailClick,
}: {
  order: OfflinePurchase;
  isDetail: boolean;
  handleDetailClick: () => void;
}) {
  return (
    <div className={styles.header}>
      <div className={styles.header__text}>
        <span className={styles.header__data}>
          {formatDate(order?.placedAt)}
        </span>
        <span className={styles.header__address}> {order.address}</span>
      </div>
      <Button
        onClick={handleDetailClick}
        className={classNames(styles.header__button, {
          [styles['header__button--active']]: isDetail,
        })}
        theme="grey"
        size="small"
      >
        <ReactSVG src="/icons/arrow-right.svg" wrapper="span" />
      </Button>
    </div>
  )
}